import React, { useState, useEffect } from 'react';
import './style.scss';
const UpdateFolio = (props) => {
    const {folioNumber} = props;
    return(
        <div className='updateFolio'>
            <p>
            You cannot proceed with folio number {folioNumber}. To proceed, first 
            update the contact details in that folio. 
            </p>
        </div>
    )
}

export default UpdateFolio;